import api from './api';

export const getAllTickets = (currentPage, PageSize, config) => {
    let errors = [];
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Ticket/GetAllTickets?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}

export const getUserTicket = (user, currentPage, PageSize, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!currentPage) {
        errors.push('current page');
    }
    if (!PageSize) {
        errors.push('page size');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Ticket/GetUserTicket/${user.id}?PageNumber=${currentPage}&PageSize=${PageSize}`, config);
    }
}

export const getTicket = (value, config) => {
    let errors = [];
    if (!value) {
        errors.push('value');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.get(`/Ticket/GetTicket/${value}`, config);
    }
}

export const addNewTicket = (user, title, description, config) => {
    let errors = [];
    if (!user) {
        errors.push('user');
    }
    if (!title) {
        errors.push('title');
    }
    if (!description) {
        errors.push('description');
    }
    if (!config) {
        errors.push('config');
    }
    if (errors.length) {
        return Promise.reject(Error(`${errors.join(', ')} parameters are missing!`));
    } else {
        return api.post(`/Ticket/AddTicket/${user.id}`, { title, description }, config);
    }
}
